export default "__VITE_ASSET__DVn8ywe6__"